var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 12.5L6.3335 7.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8611 7.5H15.6923C14.2054 7.5 13 8.61929 13 10C13 11.3807 14.2054 12.5 15.6923 12.5H17.8611C17.9306 12.5 17.9653 12.5 17.9946 12.4982C18.444 12.4709 18.802 12.1385 18.8314 11.7212C18.8333 11.6939 18.8333 11.6617 18.8333 11.5972V8.40278C18.8333 8.33829 18.8333 8.30605 18.8314 8.27883C18.802 7.86153 18.444 7.52914 17.9946 7.50178C17.9653 7.5 17.9306 7.5 17.8611 7.5Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9707 7.50016C17.9059 5.93991 17.697 4.98328 17.0235 4.30981C16.0472 3.3335 14.4759 3.3335 11.3332 3.3335L8.83317 3.3335C5.69047 3.3335 4.11913 3.3335 3.14281 4.30981C2.1665 5.28612 2.1665 6.85747 2.1665 10.0002C2.1665 13.1429 2.1665 14.7142 3.14281 15.6905C4.11913 16.6668 5.69047 16.6668 8.83317 16.6668H11.3332C14.4759 16.6668 16.0472 16.6668 17.0235 15.6905C17.697 15.017 17.9059 14.0604 17.9707 12.5002",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4927 10H15.5002",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.787eb300fcbce4bd9e89a3b011806bcd.svg";
export { ForwardRef as ReactComponent };